import { Taxes } from "./components/index"
import { InfoFiscaleProvider } from "./context"
import "./style.css"

export function InfoFiscale() {
  return (
    <>
      <InfoFiscaleProvider>
        <Taxes />
      </InfoFiscaleProvider>
    </>
  )
}
